import DOMPurify from "isomorphic-dompurify";

// Sanitize HTML that originates from YAML content before it reaches {@html}.
// The content is currently repo-authored (low risk today), so this is
// defense-in-depth that also makes the components safe if the YAML ever
// becomes CMS-/user-editable. Works in SSR (jsdom) and the browser.

// Inline rich text used in copy (headlines, table cells): only safe inline tags.
export function sanitizeRich(html: string): string {
  return DOMPurify.sanitize(html ?? "", {
    ALLOWED_TAGS: ["br", "span", "strong", "em", "b", "i", "a", "code"],
    ALLOWED_ATTR: ["href", "class", "target", "rel"]
  });
}

// Inline SVG icons authored in YAML.
export function sanitizeSvg(html: string): string {
  return DOMPurify.sanitize(html ?? "", { USE_PROFILES: { svg: true, svgFilters: true } });
}
